import React from 'react';
import { Route } from 'cccisd-laravel-boilerplate';
import defaultProps from 'recompose/defaultProps.js';
import { Switch } from 'react-router-dom';
import { Quest, ViewData } from 'cccisd-laravel-assignment';
import { Manage as AppdefManage, AdminRoutes } from 'cccisd-laravel-appdefs';

// Layouts
import MainLayout from './layouts/MainLayout';
import NavOnlyLayout from './layouts/NavOnlyLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle

// Components
import AuthRedirect from 'bundle-loader?lazy!./components/AuthRedirect';
import { ResourceCenter, ViewShare } from 'cccisd-laravel-resources';
import NavOnly from './pages/NavOnly'; // iframe for wordpress site
import CostCalcPage from './pages/CostCalc'; // iframe for wordpress site

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';
import Resources from 'bundle-loader?lazy!cccisd-laravel-resources';

// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);
const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);

var AppDefinitions = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;

const match = {
    ResourceCenter,
    AppdefManage,
    ViewData,
};

const layoutMatch = { FluidLayout: MainLayoutFluid };

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = match[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={'layout' in route ? layoutMatch[route.layout] : MainLayoutFluid}
                />
            );
        })}

        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/costCalc" component={CostCalcPage} layout={MainLayoutFluid} />

        <AppRoute path="/ncrsmhNav" component={NavOnly} exact layout={NavOnlyLayout} />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={MainLayoutFluid} />

        {/* Show Resource Admin and View Data for Uberadmins */}
        {Fortress.hasRole('uberadmin') && <AppRoute path="/resources" component={Resources} />}

        <AppRoute path="/account" component={Nexus} />

        <AppRoute key="ViewShare" path="/resource/viewshare/:id/:hash" component={ViewShare} exact />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={AuthRedirect} componentProps={{ isComponentOnly: true }} />
    </Switch>
);
